"use strict";

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = exports.BannerGroup = exports.Banner = void 0;

var _reduxOrm = require("redux-orm");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var Banner =
/*#__PURE__*/
function (_Model) {
  _inherits(Banner, _Model);

  var _super = _createSuper(Banner);

  function Banner() {
    _classCallCheck(this, Banner);

    return _super.apply(this, arguments);
  }

  _createClass(Banner, null, [{
    key: "reducer",
    value: function reducer(action, Banner, session) {
      var banner;

      switch (action.type) {
        case 'CREATE_BANNER':
          Banner.create(action.payload);
          break;

        case 'UPDATE_BANNER':
          Banner.withId(action.payload.id).update(action.payload);
          break;

        case 'REMOVE_BANNER':
          Banner.withId(action.payload.id)["delete"]();
          break;

        case 'ASSIGN_BANNER_GROUP':
          Banner.withId(action.payload.bannerId).bannerGroupId = action.payload.bannerGroupId;
          break;

        case 'TOGGLE_COLLAPSE_BANNER':
          banner = Banner.withId(action.payload.id);
          banner.update({
            collapsed: !banner.collapsed
          });
          break;

        default:
          break;
      }
    }
  }]);

  return Banner;
}(_reduxOrm.Model);

exports.Banner = Banner;
Banner.modelName = 'Banner';
Banner.fields = {
  id: (0, _reduxOrm.attr)(),
  img: (0, _reduxOrm.attr)(),
  alt: (0, _reduxOrm.attr)(),
  link: (0, _reduxOrm.attr)(),
  collapsed: (0, _reduxOrm.attr)(),
  bannerGroupId: (0, _reduxOrm.fk)('BannerGroup', 'banners')
};

var BannerGroup =
/*#__PURE__*/
function (_Model2) {
  _inherits(BannerGroup, _Model2);

  var _super2 = _createSuper(BannerGroup);

  function BannerGroup() {
    _classCallCheck(this, BannerGroup);

    return _super2.apply(this, arguments);
  }

  _createClass(BannerGroup, null, [{
    key: "reducer",
    value: function reducer(action, BannerGroup, session) {
      var bannerGroup;

      switch (action.type) {
        case 'CREATE_BANNER_GROUP':
          BannerGroup.create(action.payload);
          break;

        case 'UPDATE_BANNER_GROUP':
          BannerGroup.withId(action.payload.id).update(action.payload);
          break;

        case 'REMOVE_BANNER_GROUP':
          bannerGroup = BannerGroup.withId(action.payload.id);
          bannerGroup.banners["delete"]();
          bannerGroup["delete"]();
          break;

        case 'TOGGLE_COLLAPSE_BANNER_GROUP':
          bannerGroup = BannerGroup.withId(action.payload.id);
          bannerGroup.update({
            collapsed: !bannerGroup.collapsed
          });
          break;

        default:
          break;
      }
    }
  }]);

  return BannerGroup;
}(_reduxOrm.Model);

exports.BannerGroup = BannerGroup;
;
BannerGroup.modelName = 'BannerGroup';
BannerGroup.fields = {
  id: (0, _reduxOrm.attr)(),
  region: (0, _reduxOrm.attr)(),
  collapsed: (0, _reduxOrm.attr)(),
  menuId: (0, _reduxOrm.fk)('Menu', 'bannerGroups')
};

var Menu =
/*#__PURE__*/
function (_Model3) {
  _inherits(Menu, _Model3);

  var _super3 = _createSuper(Menu);

  function Menu() {
    _classCallCheck(this, Menu);

    return _super3.apply(this, arguments);
  }

  _createClass(Menu, null, [{
    key: "reducer",
    value: function reducer(action, Menu, session) {
      var menu;

      switch (action.type) {
        case 'CREATE_MENU':
          Menu.create(action.payload);
          break;

        case 'UPDATE_MENU':
          Menu.withId(action.payload.id).update(action.payload);
          break;

        case 'REMOVE_MENU':
          menu = Menu.withId(action.payload.id);
          menu.bannerGroups.toModelArray().map(function (bannerGroup) {
            return bannerGroup.banners["delete"]();
          });
          menu.bannerGroups["delete"]();
          menu["delete"]();
          break;

        case 'TOGGLE_COLLAPSE_MENU':
          menu = Menu.withId(action.payload.id);

          if (action.payload.region) {
            if (menu.collapsedRegions.indexOf(action.payload.region) > -1) {
              menu.update({
                collapsedRegions: menu.collapsedRegions.filter(function (region) {
                  return region !== action.payload.region;
                })
              });
            } else {
              menu.update({
                collapsedRegions: [].concat(_toConsumableArray(menu.collapsedRegions), [action.payload.region])
              });
            }
          } else {
            menu.update({
              collapsed: !menu.collapsed
            });
          }

          break;

        default:
          break;
      }
    }
  }]);

  return Menu;
}(_reduxOrm.Model);

exports.Menu = Menu;
Menu.modelName = 'Menu';
Menu.fields = {
  id: (0, _reduxOrm.attr)(),
  collapsed: (0, _reduxOrm.attr)(),
  collapsedRegions: (0, _reduxOrm.attr)({
    getDefault: function getDefault() {
      return [];
    }
  })
};